import React from 'react';
import './style.scss';
import CardsServices from 'src/views/SoftwareEngineering/components/CardsServices';
import { cardDataAiPoweredAutomation } from 'src/shared/utils/string';
import FooterServices from 'src/views/SoftwareEngineering/components/FooterServices';
import Footer from 'src/components/footer';
import BreadcrumbAiMl from '../Breadcrumb';
import { Link } from 'react-router-dom';

const AiPoweredAutomation = () => {
  return (
    <div className="page-container-ai-powered">
        <div className='image-container'>
          <div className='text-container drop-in-2'>
          <h1 className='heading drop-in'>AI-Powered Automation</h1>
          </div>
            <Link to="/ai-powered-automation" className='no-decoration '><BreadcrumbAiMl text={'AI-Powered Automation'} /></Link>
            <div className='red-bg-box'></div>
        </div>

        <CardsServices cardDataServices={cardDataAiPoweredAutomation} />
        <FooterServices />
        <Footer />
    </div>
  )
}

export default AiPoweredAutomation